import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Box, HStack, Heading, Text } from "@chakra-ui/layout";
import { CircularProgress, IconButton, Tooltip } from "@chakra-ui/react";
import ReplayRounded from "@material-ui/icons/ReplayRounded";
import Sidemenu from "../../../components/sidemenu";
import Header from "../../../components/dashHeader";
import "../../styles/dashboard/Wallet.css";
import Arrow from "../../../assets/icons/forward.svg";
import Back from "../../../assets/svg/back-arrow.svg";
import useAuth from "hooks/useAuth";
// import { fetchNotifications } from "store/slices/notification.slice";
// import { useDispatch, useSelector } from "react-redux";
import { get } from "../../../util/axiosLib";
import constant from "config/constant";
import ls from "util/secureStorage";
import { format, formatDistanceToNow, parseISO } from "date-fns";

const getToken = () => ls.get(constant.AUTH_TOKEN_KEY).token;

const getHeaders = (token = null) => ({
  authorization: token ?? getToken(),
  "Content-Type": "application/json",
});

const HomeNotification = () => {
  const { logout, token } = useAuth();

  const [loading, setLoading] = useState(true);
  const [allNotifications, setAllNotifications] = useState([]);
  const [status, setStatus] = useState("pending");
  const [pageNum, setPageNum] = useState(1);
  const [lastElement, setLastElement] = useState(null);
  const [totalPages, setTotalPages] = useState(2);

  const formatDate = useCallback(
    (createdAt) =>
      formatDistanceToNow(parseISO(createdAt), { addSuffix: true }),
    []
  );

  const observer = useRef(
    new IntersectionObserver((entries) => {
      const first = entries[0];

      if (first.isIntersecting) {
        setPageNum((no) => no + 1);
      }
    })
  );

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const URL = `${process.env.REACT_APP_API_ENDPOINT}/notifications?page=${pageNum}&limit=10`;
      const response = await get(URL, getHeaders(token));

      if (response) {
        setTotalPages(Math.ceil(response.data.data.totalCount / 5));
      }

      const all = new Set([
        ...allNotifications,
        ...response.data.data.notifications,
      ]);

      setAllNotifications([...all]);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      setStatus("error");
    }
  };

  useEffect(() => {
    if (pageNum <= totalPages) {
      fetchNotifications();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNum]);

  useEffect(() => {
    const currentElement = lastElement;
    const currentObserver = observer.current;

    if (currentElement) {
      currentObserver.observe(currentElement);
    }

    return () => {
      if (currentElement) {
        currentObserver.unobserve(currentElement);
      }
    };
  }, [lastElement]);

  return (
    <div>
      <Sidemenu currentPage={"Home"} logoutUser={() => logout()} />
      <Header />

      <section className="wallet">
        <div className="wallet-container">
          <div className="wallet-content">
            <div
              className="notification-header"
              // style={{ display: "flex", alignItems: "center" }}
            >
              <p>
                <Link to="/dashboard/home">
                  <img src={Back} className="w-backarrow" alt="back" />
                </Link>
              </p>
              <h1> Notifications </h1>
            </div>

            <div className="wallet-nav">
              <Link to="/dashboard/home" className="wallet-nav-a right-e">
                Home
              </Link>
              <img className="right-e" src={Arrow} alt="" />
              <p>
                <span className="bold"> Notifications </span>
              </p>
            </div>

            {allNotifications.length === 0 && (
              <div className="wallet-transaction-box">
                <div className="wtb-single2">
                  <p className="wtb-title"> No Notifications yet</p>
                </div>
              </div>
            )}

            {allNotifications.length !== 0 && status === "error" && (
              <div
                className="wallet-transaction-box"
                style={{ display: "flex", gap: "0.5rem" }}
              >
                <p>Something went wrong, please refresh</p>

                <IconButton
                  onClick={() => fetchNotifications()}
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                  size="xs"
                  aria-label="refetch"
                  icon={<ReplayRounded style={{ fontSize: "14px" }} />}
                />
              </div>
            )}

            {allNotifications.length > 0 && (
              <>
                <div className="wallet-transaction-box notify-box">
                  {allNotifications
                    .sort((a, b) => b.createdAt - a.createdAt)
                    .map((notification, i) => {
                      return (
                        <HStack
                          className="wtb-single2 wtb-notification"
                          // key={notification._id}
                          key={i}
                          ref={setLastElement}
                          alignItems="flex-start"
                          justifyContent="space-between"
                          gridGap="24px"
                        >
                          <div className="wtb-single-info">
                            <Box className="wtb-single-desc" w="fit-content">
                              <Heading
                                fontSize="md"
                                className="wtb-title"
                                fontWeight="bold"
                                w="fit-content"
                              >
                                {notification.title}
                              </Heading>
                              <Text
                                className="wtb-title"
                                w="fit-content"
                                fontSize="sm"
                              >
                                {notification.content}
                              </Text>
                            </Box>
                          </div>

                          <HStack className="wtb-single-amount wtb-single-notification">
                            <Tooltip
                              hasArrow
                              label={format(
                                parseISO(notification?.createdAt),
                                "eee dd, MMM yyyy, hh:mm:ss"
                              )}
                            >
                              <Text
                                // className="wtb-date"
                                whiteSpace="nowrap"
                                fontWeight="500 !important"
                              >
                                {`${formatDate(
                                  notification?.createdAt
                                )} at ${format(
                                  parseISO(notification?.createdAt),
                                  "hh:mm aa"
                                )}`}
                              </Text>
                            </Tooltip>
                          </HStack>
                        </HStack>
                      );
                    })}
                </div>
              </>
            )}

            {loading && (
              <Box as="div" mt="2rem">
                <CircularProgress isIndeterminate color="green" size="18px" />
              </Box>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeNotification;
